import type { DomainEntityConfigModule } from '@web-config-app/core';

import { EN_STRING_NODE_OVERRIDES } from './strings/nodes-strings';
import { nodesRenderers } from './renderers/nodes-renderers';

export const nodesConfig: DomainEntityConfigModule = {
  strings: {
    en: EN_STRING_NODE_OVERRIDES,
  },
  entityForm: {
    controlRenderers: nodesRenderers,
  },
};
